<template>
  <t-form labelWidth="100px">
    <t-form-item label="开启操作栏">
      <t-switch v-model="attribute.isControls" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="循环播放">
      <t-switch v-model="attribute.loop" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="自动播放">
      <t-switch v-model="attribute.autoplay" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="开启音频">
      <t-switch v-model="attribute.muted" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="视频来源">
      <t-radio-group v-model="attribute.source" size="small">
        <t-radio :value="1">在线</t-radio>
        <t-radio :value="2">本地</t-radio>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="视频地址" v-show="attribute.source === 1">
      <t-textarea :autosize="true" style="color: #fff" v-model="attribute.url" placeholder="请输入视频地址"/>
    </t-form-item>
    <t-upload v-show="attribute.source === 2" style="width: 200px;" :autoUpload="true"
              v-model="files"
              :format-response="formatResponse"
              :headers="uploadHeaders"
              @success="handleUploadSuccess"
              theme="file" :draggable="true" accept="video/*"
              :action="baseUrl+'/file/upload?dir=video'" />
  </t-form>
</template>

<script>
import {getToken} from "@/utils/auth";
import {baseUrl,fileUrl} from "/env";

export default {
  name: "cpt-video-player-option",
  props: {attribute: Object},
  data(){
    return {
      fileUrl,
      baseUrl:baseUrl,
      uploadHeaders:{'X-Token':getToken()},
      files:[]
    }
  },
  created() {
    const that = this;
    if(this.attribute.source === 2){
      this.files.push({
        url: that.fileUrl+that.attribute.fileUrl,
        name: '视频',
      })
    }
  },
  methods:{
    handleUploadSuccess(res) {
      if (res.response.code !== 200){
        this.$message.error(res.msg)
      }else{
        this.attribute.fileUrl = res.response.data
      }
    },
    formatResponse(res){
      if (res.code !== 200) {
        if(res.code === 301){
          return { error: '用户未登陆' };
        }
        return { error: '上传失败，请重试' };
      }
      return { ...res, url: res.data };
    },
  }
}
</script>

<style>
.t-upload__dragger{width:260px}
</style>